import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import CustomCard from '../../Scanners/components/CustomCard';

/**
 * Pivot Levels Table Component
 */
const PivotTable = ({ pivotLevels }) => {
  const { theme } = useTheme();

  if (!pivotLevels || pivotLevels.length === 0) {
    return null;
  }

  const formatNumber = (num) => {
    if (num == null) return '-';
    return parseFloat(num).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <CustomCard>
      <div className="overflow-x-auto -mx-4">
        <table className="w-full">
          <thead>
            <tr className={`border-b ${theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'}`}>
              <th className={`pl-6 pr-3 py-2 text-left text-sm font-medium text-n500`}>
                Type
              </th>
              <th className={`px-3 py-2 text-right text-sm font-medium text-n500`}>
                S3
              </th>
              <th className={`px-3 py-2 text-right text-sm font-medium text-n500`}>
                S2
              </th>
              <th className={`px-3 py-2 text-right text-sm font-medium text-n500`}>
                S1
              </th>
              <th className={`px-3 py-2 text-right text-sm font-medium text-n500`}>
                TCP
              </th>
              <th className={`px-3 py-2 text-right text-sm font-medium text-n500`}>
                BCP
              </th>
              <th className={`px-3 py-2 text-right text-sm font-medium text-n500`}>
                PP
              </th>
              <th className={`px-3 py-2 text-right text-sm font-medium text-n500`}>
                R1
              </th>
              <th className={`px-3 py-2 text-right text-sm font-medium text-n500`}>
                R2
              </th>
              <th className={`pl-3 pr-6 py-2 text-right text-sm font-medium text-n500`}>
                R3
              </th>
            </tr>
          </thead>
          <tbody>
            {pivotLevels.map((pivot, index) => (
              <tr
                key={index}
                className={`border-b ${theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'}`}
              >
                <td className={`pl-6 pr-3 py-2 text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.pivotlevel_name || pivot.method || pivot.name || '-'}
                </td>
                <td className={`px-3 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.s3 != null ? formatNumber(pivot.s3) : '-'}
                </td>
                <td className={`px-3 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.s2 != null ? formatNumber(pivot.s2) : '-'}
                </td>
                <td className={`px-3 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.s1 != null ? formatNumber(pivot.s1) : '-'}
                </td>
                <td className={`px-3 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.tcp != null ? formatNumber(pivot.tcp) : '-'}
                </td>
                <td className={`px-3 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.bcp != null ? formatNumber(pivot.bcp) : '-'}
                </td>
                <td className={`px-3 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.pp != null ? formatNumber(pivot.pp) : '-'}
                </td>
                <td className={`px-3 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.r1 != null ? formatNumber(pivot.r1) : '-'}
                </td>
                <td className={`px-3 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.r2 != null ? formatNumber(pivot.r2) : '-'}
                </td>
                <td className={`pl-3 pr-6 py-2 text-right text-sm font-medium ${theme === 'dark' ? 'text-[#EDEDED]' : 'text-[#272727]'}`}>
                  {pivot.r3 != null ? formatNumber(pivot.r3) : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CustomCard>
  );
};

export default PivotTable;